/**
 * Global hash scroll handler
 *
 * Ensures smooth scrolling to hash anchors or ?scroll= query parameter after page load,
 * accounting for dynamic content (Alpine.js, CKEditor, images).
 */
window.addEventListener('load', function() {
    let elementId = null;

    // Check for ?scroll= query parameter first
    const urlParams = new URLSearchParams(window.location.search);
    const scrollParam = urlParams.get('scroll');

    if (scrollParam) {
        elementId = scrollParam;
    } else if (window.location.hash) {
        elementId = window.location.hash.substring(1);
    }

    if (!elementId) return;

    const element = document.getElementById(elementId);

    if (element) {
        setTimeout(() => {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });

            // Clean up ?scroll= parameter from URL
            if (scrollParam) {
                const url = new URL(window.location);
                url.searchParams.delete('scroll');
                window.history.replaceState({}, '', url);
            }
        }, 800);
    }
});
